module.exports = __webpack_public_path__ + "img/iphonex_splash.2ff8b52f.png";